import React, { useState } from "react";

import BookingDetails from "../../BookingDetails";
import RateCalculator from "../../Calculater";
import Address from "../../Address";
import ServiceDetails from "../../ServiceDetails";
import Payment from "../../Payment";

import { ReactComponent as Book } from "../../../assests/images/SVG/bookIcon.svg";
import { ReactComponent as CalIcon } from "../../../assests/images/SVG/calIcon.svg";
import { ReactComponent as address } from "../../../assests/images/SVG/addressIcon.svg";
import { ReactComponent as payment } from "../../../assests/images/SVG/paymentIcon.svg";
import { ReactComponent as service } from "../../../assests/images/SVG/serviceIcon.svg";
import { CustomStepProgress } from "./customProgress";
import "./style.scss";

const CashBookingSteps = () => {
  const [screen, setScreen] = useState(0);

  function handleScreen(val) {
    // window.scrollTo(50, 50);
    return setScreen(val);
  }

  const steps = [
    {
      step: 1,
      title: "Rate Calculator",
      icon: CalIcon,
      content: <RateCalculator screen={handleScreen} currentScreen={screen} />,
    },
    {
      step: 2,
      title: "Booking Details",
      icon: Book,
      content: <BookingDetails screen={handleScreen} currentScreen={screen} />,
    },
    {
      step: 3,
      title: "Address",
      content: <Address screen={handleScreen} currentScreen={screen} />,
      icon: address,
    },
    {
      step: 4,
      title: "Service Details",
      content: <ServiceDetails screen={handleScreen} currentScreen={screen} />,
      icon: payment,
    },
    {
      step: 5,
      title: "Payment",
      content: <Payment screen={handleScreen} currentScreen={screen} />,
      icon: service,
    },
  ];

  return (
    <>
      <div className="steps-container">
        <CustomStepProgress steps={steps} handleScreen={screen} />
      </div>
    </>
  );
};

export default CashBookingSteps;
